import { useState } from 'react';
import { faqItems } from '@/mocks/content';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section id="faq" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Perguntas <span className="text-accent-500">Frequentes</span>
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-xl mx-auto">
            Tire suas dúvidas sobre o CSSBuy Spreadsheet e como aproveitar ao máximo
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="flex flex-col gap-3">
          {faqItems.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-foreground-950 font-semibold text-sm pr-8">{faq.question}</span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5 px-6' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}